<template>
  <i
    :class="'fa fa-fw ' + (MAX_POS_ICONS[name] || 'fa-circle-o') + (size === 'lg' ? ' fa-lg' : size === 'xl' ? ' fa-2x' : '')"
    :role="label ? 'img' : undefined"
    :aria-label="label || undefined"
    :aria-hidden="label ? undefined : 'true'"
  ></i>
</template>

<script>
import { MAX_POS_ICONS } from '~/lib/maxicons'

// Max icons in POS: the Font Awesome glyphs POS screens already use for the same things
export default {
  props: ['name', 'label', 'size'],
  setup () {
    return { MAX_POS_ICONS }
  }
}
</script>
